
import clsx from 'clsx';
import './Typo.css';

export const Typo = <T extends React.ElementType>({
  variant,
  value,
  size,
  outline,
  className
}: {
  className?: string;
  variant?: T;
  color?: string;
  value: string;
  size?: string;
  outline?: string;
}) => {
  const Component = variant || 'span';

  return (
    <Component
      className={clsx(className, {
        [`typo-${size}`]: size,
        [`typo-${outline}`]: outline,
      })}
    >
      {value}
    </Component >
  );
};
